import React from 'react';
import { useWishlist } from '../../context/WishlistContext';
import ProductCard from '../../components/ProductCard';
import { TrashIcon } from '@heroicons/react/24/outline';

const Wishlist = () => {
  const { wishlist, removeFromWishlist } = useWishlist();
  console.log('Wishlist page state:', wishlist);

  return (
    <div className="container mx-auto px-4 py-8">
      {/* <h1 className="text-3xl font-bold text-gray-800 mb-8">My Wishlist</h1> */}
      
      {Array.isArray(wishlist) && wishlist.length === 0 ? (
        <div className="text-center py-12">
          <h2 className="text-2xl text-gray-600 mb-4">Your wishlist is empty</h2>
          <p className="text-gray-500">Add some products to your wishlist to see them here!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {Array.isArray(wishlist) && wishlist.map((product) => (
            <div key={product._id || product.id} className="relative">
              <ProductCard 
               isWishlist={true}
                product={product}
                onAddToCartFromWishlist={(productId) => removeFromWishlist(productId)}
                onDelete={() => removeFromWishlist(product._id || product.id)}
              />
              {/* <button
                className="absolute top-2 right-2 bg-white rounded-full p-2 shadow hover:bg-red-100 text-red-500"
                onClick={() => removeFromWishlist(product._id || product.id)}
                aria-label="Remove from wishlist"
              >
                <TrashIcon className="h-5 w-5" />
              </button> */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist; 